// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconThumbsDownRed = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-thumbs-down-red'}
      data-name='svg-thumbs-down-red'
      data-testid='svg-thumbs-down-red'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '36'}
      height={height ?? '36'}
      viewBox={viewBox ?? '0 0 36 36'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <mask
        id='mask0_1288_30833'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='3'
        y='3'
        width='31'
        height='30'
      >
        <path
          d='M33.5 22.6081H27.9949L27.9949 3H33.5L33.5 22.6081ZM22.4899 3L9.19719 3C8.37801 3 7.65805 3.55256 7.43286 4.3541L3.64233 17.8465C3.08516 19.8298 4.21332 21.8972 6.16214 22.4642C6.49022 22.5597 6.82977 22.6081 7.17099 22.6081L16.9848 22.6081L14.5161 30.1451C14.337 30.6918 14.416 31.292 14.7301 31.7715L15.1498 32.4121C15.5471 33.0186 16.3524 33.1825 16.9484 32.7782C17.0351 32.7193 17.1145 32.6501 17.185 32.5719L25.1953 23.679C25.8157 22.9902 26.1599 22.0897 26.1599 21.1553L26.1599 6.73487C26.1599 4.67216 24.5168 3 22.4899 3Z'
          fill='#CC292D'
        />
      </mask>
      <g mask='url(#mask0_1288_30833)'>
        <path d='M-4.54052 40.5L39.5 40.5L39.5 -4.31847L-4.54052 -4.31847L-4.54052 40.5Z' fill='#CC292D' />
      </g>
    </svg>
  );
};

export default IconThumbsDownRed;
